import React from 'react';
//import logo from './logo.svg';
import './App.scss';
import { ProSidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';


function CareIMG() {
  return  <img src="./images/care.png" alt="Soins" width="50" height="50" />;  
}

function  MeditationGuideeIMG() {
  return <img src="./images/meditation-guidee.png" alt="Méditations Guidées" width="57" height="50" ></img>;
}

function MeditationIMG() {
  return <img src="./images/meditation-logo.png" alt="Méditations" width="50" height="50" ></img>;
}

function ChakraIMG() {
  return <img src="./images/chakra134-100.png" alt="Chakras, Méditation, Musiques" width="57" height="50" ></img>;
}

function MantrasIMG() {
  return <img src="./images/mantra-om.png" alt="Mantras" width="50" height="50" ></img>;
}

function MusiqueIMG() {
  return  <img src="./images/musique.png" alt="Musiques" width="50" height="50" ></img>;
}


function BinauraleMusiqueIMG() {
  return  <img src="./images/Binaurale-musique.png" alt="Musiques Binaurales" width="50" height="50" ></img>;
}

function FrequenceIMG() {
  return  <img src="./images/frequence.png" alt="Musiques Fréquences" width="50" height="50" ></img>;
}

function BrahmadevIMG() {
  return  <img src="./images/brahamadev.png" alt="Brahmadev" width="55" height="50" ></img>;
}

function ASMRIMG() {
  return <img src="./images/asmr.png" alt="ASMR" width="55" height="50" ></img>;
}

function AllIMG() {
  return <img src="./images/all.png" alt="all" width="50" height="50" ></img>;
}

function TherapeutesIMG() {
  return <img src="./images/Yin_yang.svg.png" alt="youtube channel" width="50" height="50" ></img>;
}

function LithotherapieIMG() {
  return <img src="./images/zen-stones.png" alt="youtube channel" width="50" height="50" ></img>;
}

function App() {
  return (
    <div className="App">
      <header className="App-header"> 
        {/*
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a> 
        */}
        <ProSidebar>
          <Menu iconShape="square">
            <MenuItem icon={<CareIMG />} > <a href="https://www.youtube.com/playlist?list=PLd_5fFFRWKcQRDSg98gHbEVowXPWEiwUz" target="_blank" rel="noopener noreferrer" >Soins (Méditations)</a> </MenuItem>
            <MenuItem icon={<MeditationGuideeIMG />} > <a href="https://www.youtube.com/playlist?list=PLd_5fFFRWKcQR5N9LJIehh8athKxQ4xYf" target="_blank" rel="noopener noreferrer">Méditations Guidées</a> </MenuItem>
            <MenuItem icon={<MeditationIMG />} > <a href="https://www.youtube.com/playlist?list=PLd_5fFFRWKcS2Q7eUhBXSS-ih3_TIxh_n" target="_blank" rel="noopener noreferrer">Méditations</a> </MenuItem>
            <MenuItem icon={<ChakraIMG />} > <a href="https://www.youtube.com/playlist?list=PLd_5fFFRWKcQSxJU15qspKJZrR3ImIzgu" target="_blank" rel="noopener noreferrer">Chakras, Méditation, Musiques</a> </MenuItem>
            <MenuItem icon={<MantrasIMG />} > <a href="https://www.youtube.com/playlist?list=PLd_5fFFRWKcTiBpofKjjWpHX3UapvUcEF" target="_blank" rel="noopener noreferrer">Mantras</a> </MenuItem>
            <SubMenu title="Musiques pour la Méditation" icon={<MusiqueIMG />} >
              <MenuItem icon={<BinauraleMusiqueIMG />} > <a href="https://www.youtube.com/playlist?list=PLd_5fFFRWKcRezqoie7zvXGK6va5oxwKX" target="_blank" rel="noopener noreferrer">Musiques Binaurales</a> </MenuItem>
              <MenuItem icon={<FrequenceIMG />} > <a href="https://www.youtube.com/playlist?list=PLd_5fFFRWKcQTqzqyHz80Wl4Yr9HIagly" target="_blank" rel="noopener noreferrer">Fréquences</a> </MenuItem>
              <MenuItem icon={<BrahmadevIMG />} > <a href="https://www.youtube.com/playlist?list=PLd_5fFFRWKcRDMfE8F6sYwqfhplNVnQSi" target="_blank" rel="noopener noreferrer">Brahmadev</a> </MenuItem>
            </SubMenu>
            <MenuItem icon={<ASMRIMG />} > <a href="https://www.youtube.com/playlist?list=PLd_5fFFRWKcSd8pN0A91T0E41vzv2khax" target="_blank" rel="noopener noreferrer">ASMR</a> </MenuItem>
            <MenuItem icon={<LithotherapieIMG />}> <a href="https://www.youtube.com/playlist?list=PLd_5fFFRWKcSfYX0dz_wWZdeFkHbWmAfz" target="_blank" rel="noopener noreferrer">Lithothérapie</a> </MenuItem>
            <MenuItem icon={<AllIMG />} > <a href="https://www.youtube.com/channel/UCdvr_9sGw4MKB0KJMA4KvYA/playlists" target="_blank" rel="noopener noreferrer">All</a> </MenuItem>
            <MenuItem icon={<TherapeutesIMG />} > <a href="https://www.youtube.com/channel/UCdvr_9sGw4MKB0KJMA4KvYA/channels" target="_blank" rel="noopener noreferrer">Thérapeutes – Chaînes YouTube</a> </MenuItem>
          </Menu>
        </ProSidebar>

       </header> 
    </div>
  );
}

export default App;
